const COINGECKO_BASE_URL =
    process.env.REACT_APP_COINGECKO_API_URL ||
    'https://api.coingecko.com/api/v3';
const API_KEY = process.env.REACT_APP_COINGECKO_API_KEY?.trim() || '';
const NORMALIZED_BASE_URL = COINGECKO_BASE_URL.replace(/\/$/, '');

const buildHeaders = () =>
    API_KEY ? { 'x-cg-demo-api-key': API_KEY } : {};

const request = async (path) => {
    const response = await fetch(`${NORMALIZED_BASE_URL}${path}`, {
        headers: buildHeaders(),
    });

    if (!response.ok) {
        throw new Error(`CoinGecko request failed: ${response.status}`);
    }

    return response.json();
};

export const coingeckoAPI = {
    hasApiKey: Boolean(API_KEY),

    getOHLC: (coinId, days = 365, currency = 'usd') =>
        request(`/coins/${coinId}/ohlc?vs_currency=${currency}&days=${days}`),
};
